import { EventMode, EventCategory } from '../../../../../types/eventTypes';
import { TAction } from '../../../actions/types/action';
import { IEventListItemState, TEventListState } from './types';

export const getDefaultEventDetailsState = (category: EventCategory, mode: EventMode): IEventListItemState => {
  return {
    isLoading: false,
    isLoaded: false,
    events: [],
    ui: {
      mode,
      category,
      count: 0
    }
  };
};

const getInitialState = (): TEventListState => {
  const state = {} as TEventListState;

  const modes = [EventMode.ACTIVE, EventMode.COMPLETED];

  for (const mode of modes) {
    state[mode] = {} as { [category in EventCategory]: IEventListItemState };

    for (const category of Object.values(EventCategory)) {
      state[mode][category] = getDefaultEventDetailsState(category, mode) as IEventListItemState;
    }
  }

  return state;
};

// Action Types
const VIEW_EVENTS = 'EVENTS/VIEW_EVENTS';
const LOAD_EVENTS = 'EVENTS/LOAD_EVENTS';

// Actions
type TViewEventsParams = {
  category: EventCategory;
  mode: EventMode;
};

const viewEvents = (params: TViewEventsParams) => {
  return {
    type: VIEW_EVENTS,
    payload: {
      category: params.category,
      mode: params.mode
    }
  };
};

const loadEvents = (payload: IEventListItemState): TAction<IEventListItemState> => {
  return {
    type: LOAD_EVENTS,
    payload
  };
};

export function reducer(state = getInitialState(), action: TAction<IEventListItemState>) {
  switch (action.type) {
    case LOAD_EVENTS: {
      return {
        ...state,
        [action.payload.ui.mode]: {
          ...state[action.payload.ui.mode],
          [action.payload.ui.category]: {
            ...action.payload
          }
        }
      };
    }
    default: {
      return state;
    }
  }
}

export const actions = {
  viewEvents,
  loadEvents
};

export const actionTypes = {
  VIEW_EVENTS,
  LOAD_EVENTS
};
